"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPermission = void 0;
var entity_select_transform_1 = require("../../utils/entity-select-transform");
exports.UserPermission = {
  name: 'UserPermission',
  label: 'Member Permission',
  slug: 'member-permission',
  useCreator: false,
  useOpenGraph: false,
  select: {
    defaultOptions: true,
    canCreate: function () {
      return false;
    },
    queryFields: "\n      description\n    ",
    transform: function (entity, context) {
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        description: entity.description
      });
    }
  }
};